/* Vuetify mit dem AFH-Farbschema.
 *
 * Der Hub wird sichtbar ein Werkzeug der African Football Holding. Beide
 * Themen — dunkel wie hell — stammen aus dem AFH-Player-Card-System, nicht
 * mehr aus der ursprünglichen Grassrunners-Single-File-App. Vuetify wird an
 * die Werte angepasst, nicht umgekehrt. Kein Vuetify-Standardthema.
 *
 * Quelle und Begründung der Werte: docs/farbsystem-afh.md. Wer eine Farbe
 * ändert, ändert sie dort zuerst und trägt sie danach hier nach.
 *
 * Bestehende CSS-Klassen greifen weiterhin über eigene Variablen (--bg, --card,
 * --muted …) auf die Farben zu. Diese sind in styles/main.css an die
 * Vuetify-Tokens gekoppelt und wechseln dadurch automatisch mit dem Thema mit.
 */

import { createVuetify } from 'vuetify';
/* SVG-Symbole statt Symbolschrift: Die Schriftvariante brachte 2,3 MB in vier
   Dateiformaten mit, für eine Handvoll Symbole. Hier landen nur die im Bündel,
   die tatsächlich verwendet werden. Die App wird auf Mobilgeräten offline
   vorgehalten — jedes Megabyte zählt. */
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg';
import { de, fr, es } from 'vuetify/locale';
import 'vuetify/styles';

const dark = {
  dark: true,
  colors: {
    background: '#12111F',
    surface: '#1C1B29',
    'surface-bright': '#2B2A3D',
    'surface-variant': '#1C1B29',
    'on-surface-variant': '#F4F5F8',

    primary: '#5AC2E7',
    'primary-darken-1': '#2E93BD',
    secondary: '#8CD5F0',

    success: '#5AC2E7',
    warning: '#E0A64B',
    error: '#E8808D',
    info: '#8CD5F0',

    'on-background': '#F4F5F8',
    'on-surface': '#F4F5F8',
    'on-primary': '#0B1018',

    /* Eigene Rollen, die Vuetify nicht kennt */
    border: '#2B2A3D',
    'border-soft': '#232236',
    muted: '#A9A8B8',
    dim: '#8A8999',
    neutral: '#8A9BAF',
  },
};

const light = {
  dark: false,
  colors: {
    background: '#F4F5F8',
    surface: '#FFFFFF',
    'surface-bright': '#FFFFFF',
    'surface-variant': '#FFFFFF',
    'on-surface-variant': '#1C1B29',

    primary: '#15739A',
    'primary-darken-1': '#0F5C7C',
    secondary: '#2E93BD',

    success: '#15739A',
    warning: '#B27A24',
    error: '#C1515F',
    info: '#2E93BD',

    'on-background': '#1C1B29',
    'on-surface': '#1C1B29',
    'on-primary': '#FFFFFF',

    border: '#E1E3EA',
    'border-soft': '#EDEEF3',
    muted: '#4E4D5E',
    dim: '#77768A',
    neutral: '#6F7E90',
  },
};

export const THEME_STORAGE_KEY = 'grassrunners.theme';

export function storedTheme() {
  try {
    const v = localStorage.getItem(THEME_STORAGE_KEY);
    if (v === 'dark' || v === 'light') return v;
  } catch {
    /* privates Fenster oder blockierte Speicherung — Vorgabe greift */
  }
  return 'dark';
}

export default createVuetify({
  /* Kalenderfenster (VDatePicker in DateField.vue): Monats- und Wochentagsnamen kommen aus Intl in der Sprache der
     App (DateField legt per v-locale-provider die App-Sprache fest). en-GB statt en-US, damit auch die Vorgabe der
     Woche Montag ist; DateField setzt first-day-of-week zusätzlich selbst. */
  locale: { locale: 'en', fallback: 'en', messages: { de, fr, es } },
  date: { locale: { en: 'en-GB', de: 'de-DE', fr: 'fr-FR', es: 'es-ES' } },
  theme: {
    defaultTheme: storedTheme(),
    themes: { dark, light },
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: { mdi },
  },
  defaults: {
    VBtn: { variant: 'flat', rounded: 'lg' },
    VCard: { rounded: 'lg' },
    VTextField: { variant: 'outlined', density: 'comfortable', hideDetails: 'auto' },
    VSelect: { variant: 'outlined', density: 'comfortable', hideDetails: 'auto' },
    VTextarea: { variant: 'outlined', density: 'comfortable', hideDetails: 'auto' },
  },
});
